import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin]     = useState(null);
  const [token, setToken]     = useState(() => localStorage.getItem('ct_token') || null);
  const [loading, setLoading] = useState(true);

  // Restore admin from storage on first load
  useEffect(() => {
    const stored = localStorage.getItem('ct_admin');
    if (stored && token) {
      try { setAdmin(JSON.parse(stored)); } catch { /* ignore */ }
    }
    setLoading(false);
  }, [token]);

  const login = useCallback(async (email, password) => {
    const res = await api.post('/auth/login.php', { email, password });
    const { token: t, admin: a } = res.data.data;

    localStorage.setItem('ct_token', t);
    localStorage.setItem('ct_admin', JSON.stringify(a));
    setToken(t);
    setAdmin(a);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post('/auth/logout.php'); } catch { /* ignore network errors */ }
    localStorage.removeItem('ct_token');
    localStorage.removeItem('ct_admin');
    setToken(null);
    setAdmin(null);
  }, []);

  const isAuthenticated = Boolean(token && admin);

  return (
    <AuthContext.Provider value={{ admin, token, loading, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}
